(() => {
  'use strict';

  const BUILD = '2026-07-28-computers-collection-rescue';
  document.documentElement.dataset.primeSelectBuild = BUILD;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function fixShippingCopy(scope = document) {
    scope.querySelectorAll('p').forEach((paragraph) => {
      const text = normalize(paragraph.textContent);

      if (text === 'Free U.S. shipping on all orders.' || text === 'Free U.S. shipping on all orders') {
        paragraph.innerHTML = '<strong>Free U.S. shipping</strong> on eligible orders. <a href="/policies/shipping-policy">View shipping policy</a>.';
        return;
      }

      if (text.startsWith('Orders usually process in 1–2 business days. Standard delivery is typically 2–5 business days.')) {
        paragraph.innerHTML = 'Processing and delivery estimates are shown at checkout and in our <a href="/policies/shipping-policy">Shipping Policy</a>.';
        return;
      }

      if (text.startsWith('Returns are accepted for damaged, defective, or incorrect items within 14 days of delivery.')) {
        paragraph.innerHTML = 'Return eligibility and instructions are in our <a href="/policies/refund-policy">Return &amp; Refund Policy</a>.';
      }
    });
  }

  function fixPromoLinks(scope = document) {
    scope.querySelectorAll('a.ssc-promo__cell').forEach((link) => {
      const label = normalize(link.querySelector('.ssc-promo__title')?.textContent);
      if (label === 'Shop Smart Deals') {
        link.setAttribute('href', '/collections/all?sort_by=best-selling');
      } else if (label === 'Free Shipping Support') {
        link.setAttribute('href', '/policies/shipping-policy');
      }
    });
  }

  function fixAnnouncement(scope = document) {
    scope.querySelectorAll('a, p, span').forEach((node) => {
      if (normalize(node.textContent) === 'Free U.S. shipping on all orders') {
        if (node.tagName === 'A') node.setAttribute('href', '/policies/shipping-policy');
        node.textContent = 'Free U.S. shipping on eligible orders';
      }
    });
  }

  let scheduled = false;
  function applyFixes() {
    scheduled = false;
    fixShippingCopy();
    fixPromoLinks();
    fixAnnouncement();
  }

  function scheduleFixes() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(applyFixes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes, { once: true });
  } else {
    applyFixes();
  }

  new MutationObserver(scheduleFixes).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('shopify:section:load', scheduleFixes);
  document.addEventListener('shopify:section:reorder', scheduleFixes);
})();
